export const ChatIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="-1 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.60875C0 1.91687 0.263392 1.25332 0.732233 0.764086C1.20107 0.27485 1.83696 0 2.5 0L17.5 0C18.163 0 18.7989 0.27485 19.2678 0.764086C19.7366 1.25332 20 1.91687 20 2.60875V13.0438C20 13.7356 19.7366 14.3992 19.2678 14.8884C18.7989 15.3777 18.163 15.6525 17.5 15.6525H14.375C14.1809 15.6525 13.9896 15.6997 13.816 15.7902C13.6424 15.8808 13.4914 16.0123 13.375 16.1743L11 19.4782C10.8836 19.6402 10.7326 19.7717 10.559 19.8623C10.3854 19.9529 10.1941 20 10 20C9.80594 20 9.61455 19.9529 9.44098 19.8623C9.26741 19.7717 9.11643 19.6402 9 19.4782L6.625 16.1743C6.50857 16.0123 6.35759 15.8808 6.18402 15.7902C6.01045 15.6997 5.81906 15.6525 5.625 15.6525H2.5C1.83696 15.6525 1.20107 15.3777 0.732233 14.8884C0.263392 14.3992 0 13.7356 0 13.0438V2.60875ZM6.25 7.82626C6.25 8.1722 6.1183 8.50397 5.88388 8.74859C5.64946 8.99321 5.33152 9.13063 5 9.13063C4.66848 9.13063 4.35054 8.99321 4.11612 8.74859C3.8817 8.50397 3.75 8.1722 3.75 7.82626C3.75 7.48031 3.8817 7.14854 4.11612 6.90392C4.35054 6.65931 4.66848 6.52188 5 6.52188C5.33152 6.52188 5.64946 6.65931 5.88388 6.90392C6.1183 7.14854 6.25 7.48031 6.25 7.82626ZM11.25 7.82626C11.25 8.1722 11.1183 8.50397 10.8839 8.74859C10.6495 8.99321 10.3315 9.13063 10 9.13063C9.66848 9.13063 9.35054 8.99321 9.11612 8.74859C8.8817 8.50397 8.75 8.1722 8.75 7.82626C8.75 7.48031 8.8817 7.14854 9.11612 6.90392C9.35054 6.65931 9.66848 6.52188 10 6.52188C10.3315 6.52188 10.6495 6.65931 10.8839 6.90392C11.1183 7.14854 11.25 7.48031 11.25 7.82626ZM15 9.13063C15.3315 9.13063 15.6495 8.99321 15.8839 8.74859C16.1183 8.50397 16.25 8.1722 16.25 7.82626C16.25 7.48031 16.1183 7.14854 15.8839 6.90392C15.6495 6.65931 15.3315 6.52188 15 6.52188C14.6685 6.52188 14.3505 6.65931 14.1161 6.90392C13.8817 7.14854 13.75 7.48031 13.75 7.82626C13.75 8.1722 13.8817 8.50397 14.1161 8.74859C14.3505 8.99321 14.6685 9.13063 15 9.13063Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};
export const EmailIcon = ({
  height = 22,
  width = 22,
  color = "#611FB6",
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M15.1886 0.0380859H0.811005C0.67544 0.0382448 0.545476 0.0921818 0.449636 0.188059C0.353797 0.283937 0.299911 0.413922 0.299805 0.549486V1.57829C0.299805 1.62569 0.351205 1.68009 0.393205 1.70209L7.9504 6.01869C7.96976 6.02975 7.99171 6.03548 8.014 6.03528C8.03679 6.03535 8.05918 6.02927 8.0788 6.01769L15.4076 1.70629C15.4488 1.68329 15.558 1.62249 15.599 1.59449C15.6486 1.56069 15.6998 1.53009 15.6998 1.46949V0.549286C15.6996 0.413756 15.6457 0.283823 15.5499 0.187989C15.4541 0.0921545 15.3241 0.0382447 15.1886 0.0380859Z"
        fill="#3C7EF3"
      />
      <path
        d="M15.6356 3.12922C15.6159 3.118 15.5936 3.11217 15.5709 3.11231C15.5483 3.11245 15.5261 3.11856 15.5066 3.13002L11.3592 5.57022C11.3426 5.57985 11.3285 5.59308 11.3178 5.60892C11.3071 5.62477 11.3 5.64282 11.2973 5.66174C11.2945 5.68067 11.296 5.69998 11.3017 5.71824C11.3074 5.7365 11.3171 5.75324 11.3302 5.76722L15.4782 10.2386C15.49 10.2515 15.5045 10.2618 15.5206 10.2689C15.5366 10.2759 15.554 10.2795 15.5716 10.2794C15.6054 10.2794 15.6379 10.2659 15.6619 10.2419C15.6858 10.218 15.6993 10.1855 15.6994 10.1516V3.24022C15.6994 3.21774 15.6936 3.19563 15.6824 3.17614C15.6712 3.15665 15.655 3.14046 15.6356 3.12922Z"
        fill="#3C7EF3"
      />
      <path
        d="M10.1648 6.3898C10.1451 6.36836 10.1186 6.35432 10.0898 6.35003C10.061 6.34573 10.0316 6.35144 10.0066 6.3662L8.34415 7.3444C8.24675 7.40068 8.13639 7.43066 8.02391 7.43139C7.91142 7.43213 7.80068 7.4036 7.70255 7.3486L6.23955 6.5128C6.21593 6.49935 6.18865 6.49377 6.16164 6.49686C6.13464 6.49995 6.10932 6.51156 6.08935 6.53L0.533752 11.6832C0.519187 11.6968 0.508005 11.7136 0.501096 11.7323C0.494186 11.7511 0.491742 11.7711 0.493956 11.7909C0.496171 11.8107 0.502983 11.8298 0.513851 11.8465C0.524719 11.8632 0.539341 11.8771 0.556552 11.8872C0.642952 11.938 0.726352 11.9622 0.811152 11.9622H15.0418C15.0667 11.9623 15.091 11.955 15.1118 11.9413C15.1326 11.9276 15.1489 11.9081 15.1588 11.8852C15.1687 11.8624 15.1718 11.8373 15.1676 11.8128C15.1634 11.7883 15.1521 11.7655 15.1352 11.7474L10.1648 6.3898Z"
        fill="#3C7EF3"
      />
      <path
        d="M4.86661 5.92053C4.88132 5.90692 4.89263 5.89005 4.89962 5.87127C4.90661 5.85249 4.90909 5.83233 4.90685 5.81241C4.90461 5.7925 4.89772 5.77339 4.88673 5.75663C4.87575 5.73987 4.86097 5.72593 4.84361 5.71593L0.490407 3.22953C0.470979 3.2185 0.448996 3.21276 0.426656 3.21289C0.404316 3.21302 0.382402 3.21902 0.363105 3.23028C0.343809 3.24153 0.327806 3.25766 0.316698 3.27704C0.30559 3.29643 0.299765 3.31839 0.299807 3.34073V9.86473C0.299666 9.88964 0.306834 9.91405 0.320425 9.93494C0.334016 9.95582 0.353433 9.97226 0.376272 9.98222C0.399111 9.99219 0.424369 9.99523 0.448922 9.99098C0.473474 9.98674 0.496241 9.97538 0.514407 9.95833L4.86661 5.92053Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};
export const VideoEmailIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M18.125 11.0152C17.95 11.0151 17.777 10.9782 17.6172 10.907C17.58 10.8905 17.5445 10.8704 17.5113 10.8469L14.2805 8.57266C14.1166 8.45731 13.9829 8.30427 13.8906 8.12643C13.7983 7.94859 13.75 7.75116 13.75 7.55078V4.44922C13.75 4.24884 13.7983 4.05141 13.8906 3.87357C13.9829 3.69573 14.1166 3.54269 14.2805 3.42734L17.5113 1.15312C17.5445 1.12963 17.58 1.10948 17.6172 1.09297C17.8075 1.00836 18.0159 0.97264 18.2236 0.989063C18.4312 1.00549 18.6314 1.07353 18.8061 1.18701C18.9807 1.30049 19.1242 1.45581 19.2236 1.63886C19.323 1.82191 19.375 2.02688 19.375 2.23516V9.76484C19.375 10.0964 19.2433 10.4143 19.0089 10.6487C18.7745 10.8831 18.4565 11.0148 18.125 11.0148V11.0152ZM10.4688 11.625H3.28125C2.57699 11.6243 1.90178 11.3442 1.4038 10.8462C0.90581 10.3482 0.625724 9.67301 0.625 8.96875V3.03125C0.625724 2.32699 0.90581 1.65178 1.4038 1.1538C1.90178 0.655811 2.57699 0.375724 3.28125 0.375H10.4875C11.1868 0.375827 11.8571 0.653971 12.3516 1.14842C12.846 1.64287 13.1242 2.31325 13.125 3.0125V8.96875C13.1243 9.67301 12.8442 10.3482 12.3462 10.8462C11.8482 11.3442 11.173 11.6243 10.4688 11.625Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};
export const VoiceMailIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M18.125 11.0152C17.95 11.0151 17.777 10.9782 17.6172 10.907C17.58 10.8905 17.5445 10.8704 17.5113 10.8469L14.2805 8.57266C14.1166 8.45731 13.9829 8.30427 13.8906 8.12643C13.7983 7.94859 13.75 7.75116 13.75 7.55078V4.44922C13.75 4.24884 13.7983 4.05141 13.8906 3.87357C13.9829 3.69573 14.1166 3.54269 14.2805 3.42734L17.5113 1.15312C17.5445 1.12963 17.58 1.10948 17.6172 1.09297C17.8075 1.00836 18.0159 0.97264 18.2236 0.989063C18.4312 1.00549 18.6314 1.07353 18.8061 1.18701C18.9807 1.30049 19.1242 1.45581 19.2236 1.63886C19.323 1.82191 19.375 2.02688 19.375 2.23516V9.76484C19.375 10.0964 19.2433 10.4143 19.0089 10.6487C18.7745 10.8831 18.4565 11.0148 18.125 11.0148V11.0152ZM10.4688 11.625H3.28125C2.57699 11.6243 1.90178 11.3442 1.4038 10.8462C0.90581 10.3482 0.625724 9.67301 0.625 8.96875V3.03125C0.625724 2.32699 0.90581 1.65178 1.4038 1.1538C1.90178 0.655811 2.57699 0.375724 3.28125 0.375H10.4875C11.1868 0.375827 11.8571 0.653971 12.3516 1.14842C12.846 1.64287 13.1242 2.31325 13.125 3.0125V8.96875C13.1243 9.67301 12.8442 10.3482 12.3462 10.8462C11.8482 11.3442 11.173 11.6243 10.4688 11.625Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};

export const CallIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M16.5257 19.9998C15.6541 19.9998 14.4297 19.6846 12.5963 18.6605C10.3668 17.4105 8.64237 16.2565 6.42495 14.0453C4.28701 11.9091 3.24662 10.5261 1.79052 7.87691C0.145544 4.88581 0.425958 3.31793 0.739415 2.64783C1.11271 1.84693 1.66371 1.36791 2.37591 0.892454C2.78043 0.627466 3.20852 0.400313 3.65474 0.213874C3.6994 0.194677 3.74092 0.176374 3.77798 0.159856C3.99901 0.0603008 4.3339 -0.0901474 4.75809 0.0705688C5.04119 0.17682 5.29392 0.394233 5.68953 0.784863C6.50086 1.58487 7.60957 3.36659 8.01858 4.2416C8.29319 4.83134 8.47493 5.22063 8.47537 5.65724C8.47537 6.16841 8.21818 6.56261 7.90606 6.98806C7.84756 7.06797 7.78952 7.14431 7.73325 7.21842C7.39345 7.66486 7.31888 7.79388 7.368 8.02424C7.46758 8.48719 8.21014 9.86533 9.43048 11.0828C10.6508 12.3002 11.9895 12.9957 12.4543 13.0948C12.6945 13.1462 12.8263 13.0685 13.2871 12.7167C13.3532 12.6663 13.421 12.614 13.492 12.5618C13.968 12.2078 14.344 11.9573 14.8432 11.9573H14.8459C15.2803 11.9573 15.6523 12.1457 16.2685 12.4564C17.0722 12.8618 18.9079 13.956 19.7129 14.7681C20.1045 15.1627 20.3229 15.4145 20.4296 15.6971C20.5903 16.1225 20.439 16.456 20.3403 16.6793C20.3238 16.7163 20.3055 16.7569 20.2863 16.802C20.0983 17.2474 19.8698 17.6745 19.6035 18.0779C19.1289 18.7878 18.648 19.3373 17.8451 19.711C17.4329 19.9059 16.9817 20.0047 16.5257 19.9998Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};

export const NotecardIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M3.55469 9.19531V11.664L5.69266 10.4299L3.55469 9.19531Z"
        fill="#3C7EF3"
      />
      <path
        d="M10.2073 9.19531L8.06934 10.4299L10.2073 11.664V9.19531Z"
        fill="#3C7EF3"
      />
      <path
        d="M13.5629 3.16602H0.198033C0.0886657 3.16602 0 3.25468 0 3.36405V9.87219C0.140303 9.81707 0.0200766 9.83219 2.36608 9.83219V8.17449C2.36608 8.01201 2.42674 7.85299 2.54303 7.73948C2.7393 7.54786 3.03076 7.51747 3.25723 7.64828L6.88046 9.74028L10.5036 7.64828C10.7301 7.51747 11.0216 7.54786 11.2178 7.73945C11.3341 7.85295 11.3948 8.01193 11.3948 8.17445V9.83219H13.547C13.6223 9.83219 13.6944 9.84606 13.7609 9.87219V3.36405C13.7609 3.25464 13.6722 3.16602 13.5629 3.16602Z"
        fill="#3C7EF3"
      />
      <path
        d="M11.3947 12.6925C11.3947 12.9048 11.2814 13.1012 11.0977 13.2073C11.0058 13.26 10.9032 13.2866 10.8006 13.2866C10.698 13.2866 10.5955 13.26 10.5036 13.2073L9.12565 12.4117C9.5134 13.2137 9.78393 14.1773 9.70233 15.2463C9.67858 15.558 9.41836 15.7953 9.11061 15.7953C9.09557 15.7953 9.08011 15.7945 9.06468 15.7933C8.73755 15.7683 8.49277 15.4827 8.51772 15.1556C8.65357 13.382 7.50338 11.9119 6.88159 11.2552C6.26015 11.9146 5.108 13.3908 5.24307 15.1556C5.26803 15.4828 5.02324 15.7683 4.69612 15.7933C4.68069 15.7944 4.66522 15.7953 4.65018 15.7953C4.34243 15.7953 4.08221 15.558 4.05847 15.2463C3.97687 14.1773 4.2474 13.2137 4.63515 12.4117L3.25723 13.2073C3.16533 13.26 3.06275 13.2866 2.96018 13.2866C2.85761 13.2866 2.75504 13.26 2.66313 13.2073C2.47936 13.1012 2.36608 12.9048 2.36608 12.6925V11.0234C1.66227 11.0234 0.589724 11.025 0 11.0254V19.8018C0 19.9112 0.0886657 19.9999 0.198033 19.9999H13.5628C13.6722 19.9999 13.7609 19.9112 13.7609 19.8018V11.0235H11.3948V12.6925H11.3947Z"
        fill="#3C7EF3"
      />
      <path
        d="M10.9626 0.198206C10.9626 0.0669653 10.8374 -0.0280281 10.7111 0.00751629C9.22591 0.425768 1.69839 2.54535 1.59766 2.57374H10.9626V0.198206Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};
export const LetterIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83586 0.0126953H11.6366C12.2191 0.0126953 12.6912 0.484873 12.6912 1.06737V10.8232L8.99988 13.5916L5.30852 10.8233V0.540032C5.30852 0.248801 5.54463 0.0126953 5.83586 0.0126953ZM13.7459 10.0322V4.495L17.4724 7.26376L13.7459 10.0322ZM8.99988 14.7783C9.11111 14.7783 9.22234 14.7433 9.31607 14.6727L17.9998 8.18635V17.4853C17.9998 17.7768 17.7639 18.0126 17.4724 18.0126H0.527337C0.23586 18.0126 0 17.7768 0 17.4853V8.18653L8.68369 14.6727C8.77741 14.7433 8.88865 14.7783 8.99988 14.7783ZM4.25399 10.0322V4.495L0.527337 7.26383L4.25399 10.0322Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};

export const GiftIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M10.4404 6.82812C10.1768 7.6091 9.47672 8.08355 8.70668 8.08355C8.58336 8.08355 8.46242 8.05457 8.34125 8.02977L9.2766 9.43281C9.45629 9.7023 9.38359 10.0657 9.1141 10.2454C8.84031 10.4268 8.47832 10.3484 8.30156 10.0829L7.03125 8.17738V15.0312H18.2422C19.2115 15.0312 20 14.2427 20 13.2734V6.82812H10.4404ZM17.0703 12.6875H12.3047C11.9808 12.6875 11.7188 12.4254 11.7188 12.1016C11.7188 11.7777 11.9808 11.5156 12.3047 11.5156H17.0703C17.3942 11.5156 17.6562 11.7777 17.6562 12.1016C17.6562 12.4254 17.3942 12.6875 17.0703 12.6875ZM17.0703 10.3438H12.3047C11.9808 10.3438 11.7188 10.0817 11.7188 9.75781C11.7188 9.43395 11.9808 9.17188 12.3047 9.17188H17.0703C17.3942 9.17188 17.6562 9.43395 17.6562 9.75781C17.6562 10.0817 17.3942 10.3438 17.0703 10.3438Z"
        fill="#3C7EF3"
      />
      <path
        d="M8.3368 5.68446L7.50195 6.24122L8.3368 6.79798C8.78125 7.09423 9.37535 6.77594 9.37535 6.2418C9.37535 5.70528 8.77953 5.3893 8.3368 5.68446Z"
        fill="#3C7EF3"
      />
      <path
        d="M1.75781 0.967773C0.788516 0.967773 0 1.75629 0 2.72559V5.65527H2.45023C2.84656 4.48133 4.20984 4.04715 5.20418 4.70941L5.85938 5.14629V0.967773H1.75781Z"
        fill="#3C7EF3"
      />
      <path
        d="M18.2422 0.967773H7.03125V5.14629L7.68641 4.70941C8.67023 4.05215 10.0416 4.47266 10.4406 5.65527H20V2.72559C20 1.75629 19.2115 0.967773 18.2422 0.967773Z"
        fill="#3C7EF3"
      />
      <path
        d="M4.55418 5.68476C4.10906 5.388 3.51562 5.70824 3.51562 6.24093C3.51562 6.77523 4.10758 7.0955 4.55418 6.79828L5.38902 6.24152L4.55418 5.68476Z"
        fill="#3C7EF3"
      />
      <path
        d="M4.58906 10.0829C4.40938 10.3512 4.04605 10.4227 3.77652 10.2454C3.50703 10.0657 3.43434 9.70234 3.61402 9.43281L4.54938 8.02977C4.4282 8.05457 4.30727 8.08355 4.18395 8.08355C3.41203 8.08355 2.71281 7.60719 2.44996 6.82812H0V13.2735C0 14.2428 0.788516 15.0313 1.75781 15.0313H5.85938V8.17742L4.58906 10.0829Z"
        fill="#3C7EF3"
      />
    </svg>
  );
};

export const SmsIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M15.166 0.666992H1.83268C0.916016 0.666992 0.174349 1.41699 0.174349 2.33366L0.166016 17.3337L3.49935 14.0003H15.166C16.0827 14.0003 16.8327 13.2503 16.8327 12.3337V2.33366C16.8327 1.41699 16.0827 0.666992 15.166 0.666992ZM5.99935 8.16699H4.33268V6.50033H5.99935V8.16699ZM9.33268 8.16699H7.66602V6.50033H9.33268V8.16699ZM12.666 8.16699H10.9993V6.50033H12.666V8.16699Z"
        fill="#3C7EF3"
      ></path>
    </svg>
  );
};
export const AppointmentIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M10.5 0.84375C4.89111 0.84375 0.34375 5.39111 0.34375 11C0.34375 16.6001 4.90039 21.1562 10.5 21.1562C16.1084 21.1562 20.6562 16.6084 20.6562 11C20.6562 5.3999 16.1001 0.84375 10.5 0.84375ZM15.7734 12.5625H9.91406C9.86226 12.5625 9.81258 12.5419 9.77596 12.5053C9.73933 12.4687 9.71875 12.419 9.71875 12.3672V4.16406C9.71875 4.11226 9.73933 4.06258 9.77596 4.02596C9.81258 3.98933 9.86226 3.96875 9.91406 3.96875H11.0859C11.1377 3.96875 11.1874 3.98933 11.224 4.02596C11.2607 4.06258 11.2812 4.11226 11.2812 4.16406V11H15.7734C15.8252 11 15.8749 11.0206 15.9115 11.0572C15.9482 11.0938 15.9688 11.1435 15.9688 11.1953V12.3672C15.9688 12.419 15.9482 12.4687 15.9115 12.5053C15.8749 12.5419 15.8252 12.5625 15.7734 12.5625Z"
        fill="#497ff3"
      ></path>
    </svg>
  );
};
export const AppointmentReminderIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M9.125 1.75V2.25H9.625H10.9375C11.386 2.25 11.75 2.61403 11.75 3.0625V3.875H0.5V3.0625C0.5 2.61403 0.864033 2.25 1.3125 2.25H2.625H3.125V1.75V0.5H3.875V1.75V2.25H4.375H7.875H8.375V1.75V0.5H9.125V1.75ZM1.3125 13.5C0.864033 13.5 0.5 13.136 0.5 12.6875V5.75H11.75V12.6875C11.75 13.136 11.386 13.5 10.9375 13.5H1.3125ZM9.07812 6.5C8.62151 6.5 8.25 6.87151 8.25 7.32812V8.42188C8.25 8.87849 8.62151 9.25 9.07812 9.25H10.1719C10.6285 9.25 11 8.87849 11 8.42188V7.32812C11 6.87151 10.6285 6.5 10.1719 6.5H9.07812ZM9.07812 10C8.62151 10 8.25 10.3715 8.25 10.8281V11.9219C8.25 12.3785 8.62151 12.75 9.07812 12.75H10.1719C10.6285 12.75 11 12.3785 11 11.9219V10.8281C11 10.3715 10.6285 10 10.1719 10H9.07812ZM5.57812 6.5C5.12151 6.5 4.75 6.87151 4.75 7.32812V8.42188C4.75 8.87849 5.12151 9.25 5.57812 9.25H6.67188C7.12849 9.25 7.5 8.87849 7.5 8.42188V7.32812C7.5 6.87151 7.12849 6.5 6.67188 6.5H5.57812ZM5.57812 10C5.12151 10 4.75 10.3715 4.75 10.8281V11.9219C4.75 12.3785 5.12151 12.75 5.57812 12.75H6.67188C7.12849 12.75 7.5 12.3785 7.5 11.9219V10.8281C7.5 10.3715 7.12849 10 6.67188 10H5.57812ZM2.07812 6.5C1.62151 6.5 1.25 6.87151 1.25 7.32812V8.42188C1.25 8.87849 1.62151 9.25 2.07812 9.25H3.17188C3.62849 9.25 4 8.87849 4 8.42188V7.32812C4 6.87151 3.62849 6.5 3.17188 6.5H2.07812ZM2.07812 10C1.62151 10 1.25 10.3715 1.25 10.8281V11.9219C1.25 12.3785 1.62151 12.75 2.07812 12.75H3.17188C3.62849 12.75 4 12.3785 4 11.9219V10.8281C4 10.3715 3.62849 10 3.17188 10H2.07812Z"
        fill="#3C7EF3"
        stroke="#3C7EF3"
      ></path>
    </svg>
  );
};
export const FormIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 1 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clip-path="url(#clip0_506_16158)">
        <path
          d="M7.07085 3.96228V3.10297C7.07085 2.94771 7.1972 2.82145 7.35238 2.82145H12.6473C12.8025 2.82145 12.9288 2.94779 12.9288 3.10297V3.96228C12.9288 4.11755 12.8024 4.24381 12.6473 4.24381H7.35247C7.1972 4.2439 7.07085 4.11755 7.07085 3.96228ZM11.6243 1.49889C11.5566 0.661277 10.8547 0 9.99987 0C9.14506 0 8.44314 0.661277 8.37542 1.49889H11.6243ZM16.9558 4.87881V18.2219C16.9558 19.2023 16.1581 20 15.1777 20H4.82207C3.84162 20 3.04395 19.2023 3.04395 18.2219V4.87881C3.04395 3.89836 3.84162 3.10068 4.82207 3.10068H5.74839C5.74839 3.10148 5.7483 3.10227 5.7483 3.10297V3.96228C5.7483 4.8468 6.46795 5.56636 7.35238 5.56636H12.6473C13.5318 5.56636 14.2513 4.8468 14.2513 3.96228V3.10297C14.2513 3.10218 14.2513 3.10139 14.2513 3.10068H15.1776C16.1581 3.10068 16.9558 3.89836 16.9558 4.87881ZM7.77498 12.6479C7.46409 12.4563 7.05666 12.553 6.86507 12.8639L6.23976 13.8782L5.91697 13.6239C5.63024 13.3979 5.21425 13.4474 4.98836 13.7343C4.76238 14.0213 4.81185 14.437 5.09875 14.663L6.00435 15.3762C6.12179 15.4687 6.26612 15.5179 6.41346 15.5179C6.4519 15.5179 6.49061 15.5145 6.52905 15.5077C6.71465 15.4748 6.8775 15.3641 6.97642 15.2036L7.99091 13.5578C8.18259 13.247 8.08587 12.8396 7.77498 12.6479ZM7.77498 7.88674C7.46409 7.69505 7.05666 7.79187 6.86507 8.10266L6.23976 9.11697L5.91697 8.86269C5.63024 8.6368 5.21425 8.68618 4.98836 8.97308C4.76238 9.26007 4.81185 9.6758 5.09875 9.90178L6.00435 10.615C6.12179 10.7075 6.26612 10.7567 6.41346 10.7567C6.4519 10.7567 6.49061 10.7533 6.52905 10.7465C6.71465 10.7136 6.8775 10.6029 6.97642 10.4424L7.99091 8.79674C8.18259 8.48576 8.08587 8.07842 7.77498 7.88674ZM14.6236 14.8567C14.6236 14.4914 14.3276 14.1954 13.9623 14.1954H9.64199C9.27678 14.1954 8.98071 14.4914 8.98071 14.8567C8.98071 15.222 9.27678 15.518 9.64199 15.518H13.9623C14.3276 15.518 14.6236 15.222 14.6236 14.8567ZM14.6236 10.0955C14.6236 9.7302 14.3276 9.43421 13.9623 9.43421H9.64199C9.27678 9.43421 8.98071 9.7302 8.98071 10.0955C8.98071 10.4608 9.27678 10.7568 9.64199 10.7568H13.9623C14.3276 10.7568 14.6236 10.4608 14.6236 10.0955Z"
          fill="#497ff3"
        />
      </g>
      <defs>
        <clipPath id="clip0_506_16158">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ContactIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11.75 11.8421C11.75 13.4091 12.9838 14.6842 14.5 14.6842C16.0162 14.6842 17.25 13.4091 17.25 11.8421C17.25 10.2752 16.0162 9 14.5 9C12.9838 9 11.75 10.2752 11.75 11.8421ZM19.3889 21H20V20.3684C20 17.9312 18.0805 15.9474 15.7222 15.9474H13.2778C10.9189 15.9474 9 17.9312 9 20.3684V21H19.3889Z"
        fill="#497ff3"
      ></path>
    </svg>
  );
};

export const PauseIcon = ({
  height = 22,
  width = 22,
  className = "",
  style = {},
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clip-path="url(#clip0_514_16174)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM6.07612 6.61732C6 6.80109 6 7.03406 6 7.5V12.5C6 12.9659 6 13.1989 6.07612 13.3827C6.17761 13.6277 6.37229 13.8224 6.61732 13.9239C6.80109 14 7.03406 14 7.5 14C7.96594 14 8.1989 14 8.3827 13.9239C8.6277 13.8224 8.8224 13.6277 8.9239 13.3827C9 13.1989 9 12.9659 9 12.5V7.5C9 7.03406 9 6.80109 8.9239 6.61732C8.8224 6.37229 8.6277 6.17761 8.3827 6.07612C8.1989 6 7.96594 6 7.5 6C7.03406 6 6.80109 6 6.61732 6.07612C6.37229 6.17761 6.17761 6.37229 6.07612 6.61732ZM11.0761 6.61732C11 6.80109 11 7.03406 11 7.5V12.5C11 12.9659 11 13.1989 11.0761 13.3827C11.1776 13.6277 11.3723 13.8224 11.6173 13.9239C11.8011 14 12.0341 14 12.5 14C12.9659 14 13.1989 14 13.3827 13.9239C13.6277 13.8224 13.8224 13.6277 13.9239 13.3827C14 13.1989 14 12.9659 14 12.5V7.5C14 7.03406 14 6.80109 13.9239 6.61732C13.8224 6.37229 13.6277 6.17761 13.3827 6.07612C13.1989 6 12.9659 6 12.5 6C12.0341 6 11.8011 6 11.6173 6.07612C11.3723 6.17761 11.1776 6.37229 11.0761 6.61732Z"
          fill="#497ff3"
        />
      </g>
      <defs>
        <clipPath id="clip0_514_16174">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
